module.exports = __webpack_public_path__ + "../resources/img/ic_plus_light.159c2b2e.svg";